import styled, { css } from 'styled-components';
import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import { lastMinuteDealsGradient } from '@/app/common/components/Promotions/styled.ts';
import { darkLava } from '@/app/components/search/styles/colors.ts';

const getMarkerPromotionStyle = (promotionType?: PROMOTION_TYPES, lastMinuteDeals?: boolean) => {
  switch (promotionType) {
    case PROMOTION_TYPES.JANUARY_SALE:
    case PROMOTION_TYPES.FLASH_SALES: {
      if (lastMinuteDeals) {
        return css`
          background: ${lastMinuteDealsGradient};
          img {
            width: 16px;
            height: 16px;
          }
        `;
      }

      return css`
        background: ${({ theme }) => theme.kallisto.color.common.special.flashSales[400]};
      `;
    }
    case PROMOTION_TYPES.MY_PRICE: {
      return css`
        background: ${({ theme }) => theme.kallisto.color.common.special.myPrice[500]};
      `;
    }
    case PROMOTION_TYPES.LOYALTY: {
      return css`
        background: ${darkLava};
        width: 48px;

        img {
          width: 32px;
          height: 12px;
        }
      `;
    }
    default: {
      return css`
        background: white;
      `;
    }
  }
};

export const MarkerPromotionStyled = styled.div<{
  promotionType?: PROMOTION_TYPES;
  lastMinuteDeals?: boolean;
}>`
  display: flex;
  height: 28px;
  width: 26px;
  border-radius: 8px 0 0 8px;
  align-items: center;
  justify-content: center;

  ${({ promotionType, lastMinuteDeals }) => getMarkerPromotionStyle(promotionType, lastMinuteDeals)};
`;
